var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.9;fill:url(#SVGID_00000087413979790737727530000011114090790148114309_);enable-background:new    ;}\n\t.st2{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st3{opacity:0.5;fill:url(#SVGID_00000173866758220751864350000011514650460513896363_);enable-background:new    ;}\n\t.st4{opacity:0.6;fill:url(#SVGID_00000046325702562402398100000008588168176639308702_);enable-background:new    ;}\n\t.st5{opacity:0.9;fill:url(#SVGID_00000086668914478830672470000017567272723260613798_);enable-background:new    ;}\n\t.st6{opacity:0.4;fill:url(#SVGID_00000151545369230114989500000009340556304610313620_);enable-background:new    ;}\n\t.st7{opacity:0.5;fill:url(#SVGID_00000037677475643920598680000005193095562180677283_);enable-background:new    ;}\n\t.st8{opacity:0.9;fill:url(#SVGID_00000158712522983176665360000000389834507735461810_);enable-background:new    ;}\n\t.st9{opacity:0.3;fill:url(#SVGID_00000019680145586986283130000000567137372287354524_);enable-background:new    ;}\n\t.st10{opacity:0.4;fill:url(#SVGID_00000168110903925981658070000018155722347997337242_);enable-background:new    ;}\n\t.st11{opacity:0.4;fill:url(#SVGID_00000150091677931303929740000006449388794212794046_);enable-background:new    ;}\n\t.st12{opacity:0.4;fill:url(#SVGID_00000111913243231927531990000014429451489998236589_);enable-background:new    ;}\n\t.st13{opacity:0.4;fill:url(#SVGID_00000162335232756788721430000017735098469719625897_);enable-background:new    ;}\n\t.st14{opacity:0.5;fill:url(#SVGID_00000111181345906325601400000016760684883272806844_);enable-background:new    ;}\n\t.st15{opacity:0.5;fill:url(#SVGID_00000096020295443590541910000017820940717463852929_);enable-background:new    ;}\n\t.st16{opacity:0.5;fill:url(#SVGID_00000018952674674215496200000002432383969670657439_);enable-background:new    ;}\n\t.st17{opacity:0.6;fill:url(#SVGID_00000112616789247208079150000016963115302006920358_);enable-background:new    ;}\n\t.st18{opacity:0.5;fill:url(#SVGID_00000080917994296711030480000015418026231476025275_);enable-background:new    ;}\n\t.st19{opacity:0.6;fill:url(#SVGID_00000023959460179562325150000015006233589876993690_);enable-background:new    ;}\n\t.st20{opacity:0.3;fill:url(#SVGID_00000063603007946521742050000015754733077861351594_);enable-background:new    ;}\n\t.st21{opacity:0.3;fill:url(#SVGID_00000036951507260815704290000009840250714117549460_);enable-background:new    ;}\n\t.st22{opacity:0.3;fill:url(#SVGID_00000041979004269283503960000001868373323263897504_);enable-background:new    ;}\n\t.st23{opacity:0.3;fill:url(#SVGID_00000090999355588580949990000000126734540545595573_);enable-background:new    ;}\n\t.st24{opacity:0.3;fill:url(#SVGID_00000075866324976746425150000004722188489295817856_);enable-background:new    ;}\n\t.st25{opacity:0.3;fill:url(#SVGID_00000088824886801452155470000001678572929192179848_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.9196,
    y1: 398.971,
    x2: 1990.6398,
    y2: 1992.8993,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6007A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#703AC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#0070EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#0297FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0AE2FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2496.8,1165.2C2450,476.4,1853.8-43.9,1165.1,2.9c-343,23.4-644.3,183.2-854.5,422.5l-0.6-0.4   c-1.5,1.9-2.8,3.8-4.1,5.8c-208.8,240.9-326.3,560.9-303,904c2.2,32.8,6,64.8,10.7,96.7c0,1.5,0.4,2.8,0.6,4.3   c3.2,21,6.9,42,10.9,62.5c3.8,19,8.1,37.9,12.8,56.7c144.4,575.7,683.7,983.4,1296.8,941.7c688.6-46.8,1209.1-643,1162.3-1331.8   C2497.1,1164.8,2496.8,1165.2,2496.8,1165.2z M2224.7,1183.8c5.8,84.8,0.4,167.8-14.8,247.8c0-0.4-0.4-0.8-0.4-1.3   c-90.8-221.4-270-381.4-427.5-469.8c31.9-375.2-95.4-533.5-239.6-559.2c-113.2-21.3-222.2,53.3-243.5,166.5   c-0.8,4-1.4,8.1-1.9,12.2c-14.7,114.2,65.9,218.8,180.1,233.5c0.2,0,0.3,0,0.5,0.1c10,1.3,19.9,1.7,29.5,1.5   c0.7,13.4,1.1,26.8,1.1,40.2c-133.3-32.9-257.8-39.6-371.4-29.3c-42.7,2.8-85.2,8.2-127.3,16c14.2-126.7,61.8-269.1,154-373.1   c89.2-100.8,221.8-158.3,366.4-143.5c27.4,2.8,56.7,9.6,83,18.4c1.3,0.4,2.6,0.8,3.7,1c335,136.5,581.7,454.6,607.8,839   C2224.5,1183.8,2224.7,1183.8,2224.7,1183.8z M1353.4,1374.7c0,0,0,0.2-0.2,0.4c-31.6,45.4-67.4,87.8-107,126.5   c-59.9-63.3-110.6-134.6-150.6-212c-1.9-4.1-4-7.7-6-11.8v-0.4c-23.5-50.1-42.2-102.4-56-156c88.8-21,175.8-28.7,259.1-24.6   l13.3,0.6h0.4c52.2,4.3,106.5,13.9,162.8,29.3c-26.1,87.8-65,171.3-115.5,247.7C1353.6,1374.5,1353.4,1374.7,1353.4,1374.7z    M926.4,327.9l-0.6,0.8C779.3,517.9,730.5,753,732.6,933.5c-341,160-414.2,349.3-364.5,487.1c1.2,3.9,2.8,7.5,4.3,11.2   c44.5,106.3,166.8,156.5,273.2,112.1c106.3-44.5,156.5-166.8,112.1-273.2c-3.9-9.1-8.4-17.9-13.5-26.3   c10.7-7.1,22.3-14.1,34.7-21.4c38,132,94.3,243.5,160,336.7c23.8,35.3,49.4,69.3,77.4,102c-116.8,51.1-264,81.1-400.3,53.3   c-131.8-26.9-247.9-112.9-307.6-245.6c-11.4-26-20-53.2-25.7-81c-3.5-23.9-6.2-48-7.9-72.1C244.4,868.5,522.1,470,926.4,327.9z    M1316.2,2224.8c-265.9,18.2-514.5-72.5-702.3-233.8c237,32.3,465.1-43,620.4-135.2c309.1,215.4,509.8,184.2,604.3,72.3   c75.1-87.5,65-219.3-22.5-294.4c-3.1-2.7-6.3-5.2-9.6-7.7c-91.7-69.9-222.7-52.2-292.6,39.5c0,0-0.1,0.1-0.1,0.1   c-6,7.9-11.3,16.5-16,25c-11.3-5.8-23.3-12.2-35.5-19.3c87.1-89.9,158.5-193.7,211.1-307.2c18.9-38.4,35.4-77.9,49.6-118.3   c102.7,75.8,202.4,188,246.5,320c42.6,127.5,26.3,271.3-58.8,389.2c-16.8,22.9-36,43.9-57.3,62.7l-0.8,0.8   c-153.8,121.2-340.7,193-536.1,206C1316.4,2224.6,1316.2,2224.8,1316.2,2224.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121237179412258264440000001769130992065460122_",
    cx: 138.3355,
    cy: 2415.8018,
    r: 41.667,
    gradientTransform: "matrix(11.408 0 0 -11.408 28.142 28556.332)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000121237179412258264440000001769130992065460122_)",
      enableBackground: "new"
    },
    d: "   M1542.5,401.1c-23.4-4.5-47.5-4.7-71-0.8c119.6,65,206.7,246.2,160.9,603.9c-15.1,116.3-49.3,229.4-101.2,334.6   c-44.7,96-102.8,185.2-172.7,264.8c33.1,24.9,67.8,47.7,103.8,68.3c87.1-89.8,158.5-193.7,211.2-307.2   c52-105.2,86.1-218.2,101.2-334.6c54.6-425.7-79.3-601.5-232.1-628.8L1542.5,401.1L1542.5,401.1z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1632.4,1003.9c45.8-357.5-41.3-538.9-160.9-603.9c-4.7,0.6-9.2,1.7-13.9,2.8   c117,67.4,201.3,248.3,156.2,601.1c-15.1,116.3-49.3,229.4-101.2,334.6c-43.1,92.6-98.7,178.9-165.4,256.3c3.8,3,7.5,5.8,11.3,8.5   c69.8-79.7,127.9-168.8,172.6-264.8C1583.1,1233.3,1617.3,1120.3,1632.4,1003.9L1632.4,1003.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096752103115807184890000012475104098377712026_",
    cx: 133.7249,
    cy: 2224.9426,
    r: 41.667,
    gradientTransform: "matrix(6.6384 0 0 -6.6384 16.0516 16648.7012)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000096752103115807184890000012475104098377712026_)",
      enableBackground: "new"
    },
    d: "   M1177.8,1814.9c-11.3-8.5-22-17.5-32.9-26.5c-176.5,73.6-421,119.8-664,63.3c39.6,50.7,84.1,97.3,132.8,139.3   c237,32.3,465.1-43,620.4-135.2c-19.1-13.3-37.9-27-56.5-41.1L1177.8,1814.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119114085072472739250000015632712470677052304_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.7235,
    y1: 670.1664,
    x2: 755.3088,
    y2: 673.8331,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000119114085072472739250000015632712470677052304_)",
      enableBackground: "new"
    },
    d: "   M1145,1788.4c-5.3-4.5-10.9-9-16-13.5c-177.8,71-423.6,113.6-666,53c6,7.9,12,16,18,23.8C723.9,1908.2,968.6,1862,1145,1788.4   L1145,1788.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164500726523486376710000010611288912246936239_",
    cx: -114.4733,
    cy: 2483.5327,
    r: 41.667,
    gradientTransform: "matrix(-5.704 -9.8796 -9.8796 5.704 24736.0918 -14229.1973)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000164500726523486376710000010611288912246936239_)",
      enableBackground: "new"
    },
    d: "   M368.3,1420.9c1.2,3.8,2.8,7.5,4.3,11.1c7.9,18.8,18.2,35.7,30.6,50.9c-3.4-136,110-302.3,442.4-441.3   c108.3-45,223.3-71.9,340.3-79.6c105.5-9.4,211.9-3.6,315.8,17.1c5.4-44.9,7.5-86.8,7.1-123.9c-121.3-30.5-247-40.4-371.6-29.3   c-117.1,7.7-232.1,34.6-340.4,79.6c-395.9,165.6-481.3,369.5-428.4,515.5L368.3,1420.9L368.3,1420.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M845.6,1041.8c-332.4,139.1-445.8,305.3-442.4,441.3c3,3.6,6.2,7.1,9.4,10.5c-0.2-135,114.4-298.4,442.4-435.8   c108.3-45,223.3-71.9,340.3-79.6c101.7-9,204.3-4,304.6,15c0.7-4.7,1.2-9.4,1.7-14.1c-103.9-20.6-210.2-26.4-315.8-17.1   c-117,7.7-232,34.6-340.3,79.6C845.6,1041.6,845.6,1041.8,845.6,1041.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070810537205548785670000000655587390690645422_",
    cx: -300.7343,
    cy: 2341.3372,
    r: 41.667,
    gradientTransform: "matrix(-3.3192 -5.749 -5.749 3.3192 14429.8057 -8264.8975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000070810537205548785670000000655587390690645422_)",
      enableBackground: "new"
    },
    d: "   M1775.1,1029.8c-1.7,14.1-4,27.8-6.4,41.7c151.9,116,314.3,304.8,387,543.3c24-59.7,42.2-121.6,54.1-184.8   c-90.5-221.4-269.8-381.3-427.2-469.6c-1.9,22.5-4.3,45.4-7.3,69.3C1775.3,1029.8,1775.1,1029.8,1775.1,1029.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029005020302770022920000003679355298427017861_",
    gradientUnits: "userSpaceOnUse",
    x1: 2134.2878,
    y1: 883.8452,
    x2: 1997.8284,
    y2: 1112.8469,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000029005020302770022920000003679355298427017861_)",
      enableBackground: "new"
    },
    d: "   M1768.6,1071.5c-1.3,6.8-2.4,13.9-3.7,20.8c150.4,118.5,310.2,310,378.9,550.2c4-9.2,7.9-18.4,11.5-27.6   c-72.7-238.5-234.9-427.2-387-543.4C1768.4,1071.5,1768.6,1071.5,1768.6,1071.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116937313286004328970000008248919916257101452_",
    cx: 69.9252,
    cy: 2665.9954,
    r: 41.667,
    gradientTransform: "matrix(-5.704 9.8796 9.8796 5.704 -24671.7793 -14234.6729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000116937313286004328970000008248919916257101452_)",
      enableBackground: "new"
    },
    d: "   M1838.6,1927.9c15.5-18.2,27.8-38.9,36.4-61.2c-116.2,71-316.7,55.8-603.5-162.6c-93.2-71.2-174.1-157.4-239.2-255   c-60.9-86.7-109.1-181.6-143.1-281.9c-41.5,17.8-78.9,37-111,55.8c34.3,120.3,88.5,234.1,160.4,336.5   c64.2,95.8,144.2,182.5,239.2,255c341.4,260.1,560.7,232.1,660.6,113.3L1838.6,1927.9L1838.6,1927.9z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1271.7,1704.1c286.6,218.4,487.3,233.6,603.4,162.5c1.7-4.5,3.2-9,4.5-13.3c-116.8,67.8-315.8,50-598.5-165.3   c-93.2-71.2-174.1-157.4-239.2-255c-58.7-83.6-105.5-174.9-139.3-271.3c-4.5,1.9-8.8,3.6-13,5.5c34,100.3,82.2,195.3,143.1,282   c64.2,95.8,144.2,182.5,239.2,255L1271.7,1704.1L1271.7,1704.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075883710936137678610000013373461902048861081_",
    cx: 17.3308,
    cy: 2659.3882,
    r: 41.667,
    gradientTransform: "matrix(-3.3192 5.749 5.749 3.3192 -14352.8623 -8290.7832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000075883710936137678610000013373461902048861081_)",
      enableBackground: "new"
    },
    d: "   M796.6,905.1c13-5.4,26.1-10.3,39.3-15.2c24.4-189.5,106.8-424.6,277.1-606.7c-63.8,9.2-126.5,24.2-187.2,45.3   C779.2,517.7,730.4,752.8,732.6,933.4c20.3-9.6,41.5-19,63.8-28.2L796.6,905.1L796.6,905.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115478165298486702690000001917077249964883870_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.074,
    y1: 2202.4202,
    x2: 996.1147,
    y2: 1969.6268,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000115478165298486702690000001917077249964883870_)",
      enableBackground: "new"
    },
    d: "   M835.9,889.9c6.7-2.3,13.1-4.9,19.7-7.3c27.4-189.6,113.4-423.6,286.9-603.3c-9.8,1.1-19.7,2.4-29.5,3.7   c-170.3,182.3-252.6,417.1-277,606.7L835.9,889.9L835.9,889.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132068684958943484550000003906830218035043007_",
    gradientUnits: "userSpaceOnUse",
    x1: 1184.455,
    y1: 2320.5364,
    x2: 777.1187,
    y2: 2202.0356,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000132068684958943484550000003906830218035043007_)",
      enableBackground: "new"
    },
    d: "   M1165.1,3C822,26.3,520.8,186.1,310.6,425.5l-4.7,5.3c40.8,40.7,174.8,120.7,228.9,154c107.9-116.2,242.4-204.4,392-256.9   c10.5-13.7,21.6-27.2,33.2-40.2C1101,128.4,1293.8,44.3,1517.5,44.3c24.8,0,75.5,4.1,76.6,4.1C1454.9,8.3,1309.7-7.1,1165.1,3   L1165.1,3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158718385986789613700000015188472863308649143_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.8612,
    y1: 767.4369,
    x2: 755.447,
    y2: 411.9342,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000158718385986789613700000015188472863308649143_)",
      enableBackground: "new"
    },
    d: "   M1316.2,2225c-265.9,18.2-514.5-72.5-702.3-233.8c-17.6-2.3-35.2-5.2-52.6-8.8c-208.6-42.6-378-167.5-489.7-361.1   c-12.3-21.4-23.5-43.4-33.6-65.9c144.4,575.7,683.7,983.4,1296.6,941.7c2.8-63.1-15.8-209.6-18.6-272.1   C1316,2225,1316.2,2225,1316.2,2225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061451103435490879480000007041781104899025285_",
    gradientUnits: "userSpaceOnUse",
    x1: 2242.7075,
    y1: 821.0139,
    x2: 2361.2083,
    y2: 1181.2664,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000061451103435490879480000007041781104899025285_)",
      enableBackground: "new"
    },
    d: "   M2496.9,1165.2c-38.5-3.9-225.9,10.9-272.1,18.6c5.8,84.8,0.4,167.8-14.8,247.8c6.4,15.8,12.6,32.1,18.2,48.5   c67.4,202,43.9,411-67.8,604.8c-12.4,21.4-25.8,42.1-40.2,62.1c0,0,0.6-0.5,0.8-0.9c254-247.1,401.8-599.6,375.9-980.6   C2496.9,1165.5,2496.9,1165.2,2496.9,1165.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119814931886502904010000001316367624910251430_",
    gradientUnits: "userSpaceOnUse",
    x1: 1369.9131,
    y1: 2114.4612,
    x2: 1915.8755,
    y2: 1989.502,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000119814931886502904010000001316367624910251430_)",
      enableBackground: "new"
    },
    d: "   M1530.4,325.2c27.4,2.8,56.7,9.6,83,18.4c1.2,0.4,2.6,0.8,3.6,1c107.3,43.8,206,106.2,291.6,184.4c0,0,0.4,0.2,0.6,0.4   c41.1-46.8,120-98.4,120-98.4s-120.8-123.7-305.9-162.2c-129.4-27-421.4-52.8-605.6,260.5l1.7-1.7c13.7-20.6,28-40.7,44.5-59.1   C1253.1,367.9,1385.7,310.4,1530.4,325.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091714172966555118190000003300969730264655780_",
    gradientUnits: "userSpaceOnUse",
    x1: 1936.9243,
    y1: 716.9786,
    x2: 1555.4633,
    y2: 306.5591,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000091714172966555118190000003300969730264655780_)",
      enableBackground: "new"
    },
    d: "   M1910.7,1955.2c-16.8,22.9-36,43.9-57.3,62.7c-0.8,0.8-1.9,1.7-2.8,2.6c-91.6,71-195,125.2-305.5,160.2c-0.2,0-0.4,0-0.7,0.2   c20.1,59,25.3,153.2,25.3,153.2s167.5-42.8,293.3-183.8c87.9-98.6,256.5-338.6,77.2-654.8c0,0,0.2,1,0.7,2.3   c11.1,22.1,21.2,44.7,28.9,68c42.6,127.5,26.3,271.3-58.8,389.1C1910.9,1955,1910.7,1955.2,1910.7,1955.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036950726361141302440000006222968405638575539_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.0019,
    y1: 924.405,
    x2: 278.4173,
    y2: 1459.7839,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000036950726361141302440000006222968405638575539_)",
      enableBackground: "new"
    },
    d: "   M308.9,1469.9c-11.4-26-20.1-53.2-25.7-81.1c-0.2-1.2-0.6-2.6-0.8-3.9c-15.8-115.3-10.7-232.1,13.9-344.6v-0.7   c-61.2-12-145.3-54.8-145.3-54.8s-46.7,166.7,12.6,345.9c41.5,125.5,164.9,391.5,528.3,394.3c0,0-1-0.2-2.3-0.7   c-24.6-1.5-49.2-4-73.3-9c-131.8-27-248-113-307.7-245.6C308.6,1469.9,308.9,1469.9,308.9,1469.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179631255623736361880000002276906711789936813_",
    gradientUnits: "userSpaceOnUse",
    x1: 1489.2032,
    y1: 1913.1648,
    x2: 1316.577,
    y2: 1740.2886,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000179631255623736361880000002276906711789936813_)",
      enableBackground: "new"
    },
    d: "   M1477.7,813.4c10,1.2,19.9,1.7,29.5,1.5c0,0-6.6-129.8-22.5-196.6c-16-66.5-39.6-110.8-65.3-135.8c-18.6-18-77-40.3-122.3,97.1   c-14.8,114.2,65.9,218.8,180.1,233.6c0.2,0,0.3,0,0.5,0.1V813.4L1477.7,813.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014596901508396858940000009987249175014289597_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.8235,
    y1: 1128.7568,
    x2: 793.7419,
    y2: 1065.3813,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000014596901508396858940000009987249175014289597_)",
      enableBackground: "new"
    },
    d: "   M757.9,1271.1c-3.9-9.1-8.4-17.8-13.5-26.3c0,0-109.3,70.6-159,117.6c-49.6,47.1-76.2,89.7-84.9,124.5c-6.2,25,3.6,86.7,145.3,57.3   C752.2,1499.8,802.3,1377.5,757.9,1271.1L757.9,1271.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109711059408397418700000017697695836328441990_",
    gradientUnits: "userSpaceOnUse",
    x1: 1702.6029,
    y1: 714.3469,
    x2: 1639.3943,
    y2: 950.1819,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000109711059408397418700000017697695836328441990_)",
      enableBackground: "new"
    },
    d: "   M1514.1,1665.4c-6,7.9-11.3,16.5-16,25c0,0,115.8,59.3,181.4,78.8c65.7,19.5,115.7,21.2,150.2,11.3c24.8-7,73.2-46.6-22.9-154.4   c-91.7-69.9-222.7-52.2-292.6,39.5c0,0,0,0.1-0.1,0.1C1514.1,1665.6,1514.1,1665.4,1514.1,1665.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152985283442859556740000009854681052421710223_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.2557,
    y1: 924.2623,
    x2: 1447.0063,
    y2: 1067.3467,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000152985283442859556740000009854681052421710223_)",
      enableBackground: "new"
    },
    d: "   M1469.2,1126.9c-26.3,87.3-63.1,166.7-108.2,236.6c-2.4,3.6-4.7,7.3-7.3,11.1c0,0,0,0.2-0.2,0.4c-31.6,45.4-67.4,87.8-107,126.5   c28.7,30.4,59.5,59.9,93.5,87.9c38.7,30.4,79.6,57.9,122.3,82.1c87.1-89.8,158.5-193.7,211.2-307.2c18.8-38.4,35.4-77.9,49.6-118.3   c-44-32.3-88.5-58.2-129.6-75.7c-40.5-17.3-82.1-31.8-124.5-43.4L1469.2,1126.9L1469.2,1126.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113321247363267839740000007701393365243228062_",
    gradientUnits: "userSpaceOnUse",
    x1: 986.5562,
    y1: 986.2267,
    x2: 779.263,
    y2: 887.3927,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000113321247363267839740000007701393365243228062_)",
      enableBackground: "new"
    },
    d: "   M613.9,1991.2c237,32.3,465-43,620.4-135.2c-19.1-13.3-37.9-27-56.5-41.1c-59.1-45.2-113.3-96.4-161.7-152.9   c-116.8,51.1-264,81-400.3,53.2c-131.8-26.9-247.9-112.9-307.6-245.5c-11.4-26-20-53.2-25.7-81.1   c34.5,241.7,156.4,452.6,331.2,602.6L613.9,1991.2L613.9,1991.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140721166076825641770000012701597224707753406_",
    gradientUnits: "userSpaceOnUse",
    x1: 911.5067,
    y1: 1331.3312,
    x2: 975.6738,
    y2: 1198.0385,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000140721166076825641770000012701597224707753406_)",
      enableBackground: "new"
    },
    d: "   M1246.5,1501.5c-59.9-63.3-110.6-134.6-150.6-212c-1.9-4.1-4.1-7.7-6-11.8v-0.4c-23.5-50.1-42.2-102.4-56-156   c-40.7,9.6-81.5,21.6-122.6,37c-45.6,18.2-89.8,39.8-132.2,64.6c38.1,132,94.3,243.5,160,336.7c23.8,35.3,49.5,69.3,77.5,102   c50-21.8,94.8-47.7,130.4-74.5c35.1-26.4,68.4-55.1,99.7-86C1246.7,1501.3,1246.5,1501.5,1246.5,1501.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111904434583698469790000018055620601800452018_",
    gradientUnits: "userSpaceOnUse",
    x1: 1209.5768,
    y1: 1742.7588,
    x2: 1165.2847,
    y2: 1895.7181,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000111904434583698469790000018055620601800452018_)",
      enableBackground: "new"
    },
    d: "   M925.9,328.8C779.3,517.9,730.5,753,732.7,933.5c21.1-9.9,42.4-19.4,64-28.4c68.6-28.6,140-49.9,213-63.5   c14.2-126.7,61.8-269.1,154-373.1c89.2-100.8,221.8-158.3,366.5-143.5c27.4,2.8,56.7,9.6,83,18.4c1.2,0.4,2.5,0.8,3.6,1   c-137.3-56-285.6-79.8-433.5-69.5c-89.8,6.2-175.8,24.4-257.1,53c-0.2,0.2-0.4,0.6-0.6,0.8H925.9L925.9,328.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132075790150937219830000010748825154675994532_",
    gradientUnits: "userSpaceOnUse",
    x1: 1688.5017,
    y1: 1042.299,
    x2: 1816.8361,
    y2: 1012.7571,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000132075790150937219830000010748825154675994532_)",
      enableBackground: "new"
    },
    d: "   M2209.8,1429.9c-90.7-221.4-270-381.5-427.4-469.8c-1.9,22.5-4.2,45.6-7.5,69.8c-9.5,73.7-26.8,146.2-51.5,216.3   c102.7,75.8,202.4,188,246.5,320c42.5,127.5,26.3,271.3-58.8,389.1c-16.8,22.9-36,43.9-57.3,62.7l-0.8,0.8   c183.5-144.2,313.3-352.1,357.9-587.4c0-0.4-0.4-0.9-0.4-1.3L2209.8,1429.9L2209.8,1429.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040545226463394457850000009366272063519612060_",
    gradientUnits: "userSpaceOnUse",
    x1: 1487.1616,
    y1: 1475.8788,
    x2: 1324.3688,
    y2: 1505.4207,
    gradientTransform: "matrix(1 0 0 -1 0 2502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000040545226463394457850000009366272063519612060_)",
      enableBackground: "new"
    },
    d: "   M1009,992.2c5.2,43.6,13.4,86.8,24.6,129.2c88.8-21,175.8-28.7,259.1-24.6l13.3,0.6h0.4c52.2,4.3,106.5,13.9,162.8,29.3   c12-40,22-81.5,29.3-124.8c7.9-53.9,10.2-103.8,10-147.2c-133.3-32.9-257.8-39.6-371.3-29.3c-42.7,2.8-85.2,8.2-127.3,16   c-6,54.3-6.2,105.9-0.7,150.4C1009.2,992,1009,992.2,1009,992.2z"
  })));
};
export default SvgLogoNoText;